import React from "react";
import Layout from "../components/layout/Layout";

const Enroll = () => {
  return (
    <Layout>
      <div className="p-8">
        <h1 className="text-3xl font-bold">Enroll</h1>
      </div>
    </Layout>
  );
};

export default Enroll;
